export const GATEWAY_API_URL = import.meta.env['VITE_GATEWAY_API_URL'];
export const COSMOPOLITAN_URL = import.meta.env['VITE_COSMOPOLITAN_URL'] as string | undefined;
export const STYLIST_API_URL = import.meta.env['VITE_STYLIST_API_URL'];
export const CRM_ADMIN_API_URL = import.meta.env['VITE_CRM_ADMIN_API_URL'];
export const PORTAL_NAME = import.meta.env['VITE_PORTAL_NAME'] as
  | 'admin'
  | 'vendor'
  | 'warehouse'
  | 'synq'
  | 'logistics';
export const UNICOMMERCE_PORTAL_URL = import.meta.env['VITE_UNICOM_URL'];
export const APP_ENV = import.meta.env['VITE_APP_ENV'];
export const APP_MODE = import.meta.env.MODE;
export const SHOULD_HIDE_CUSTOMER_PHONE = PORTAL_NAME === 'vendor';
export const IS_LOCAL_ENV = APP_MODE === 'local' || APP_ENV === 'local';
export const IS_STAGE_ENV =
  APP_MODE === 'stage' || APP_MODE === 'staging' || APP_ENV === 'stage' || APP_ENV === 'staging';
export const IS_PROD_ENV =
  (APP_MODE === 'prod' || APP_MODE === 'production') &&
  (APP_ENV === 'prod' || APP_ENV === 'production');

// Explicit opt-in for running prod-only Foundation tools against local services.
export const LOCAL_DEVELOPER_FEATURES_ENABLED =
  IS_LOCAL_ENV && import.meta.env['VITE_ENABLE_LOCAL_DEVELOPER_FEATURES'] === 'true';
export const PRODUCTION_FEATURES_VISIBLE = IS_PROD_ENV || LOCAL_DEVELOPER_FEATURES_ENABLED;
export const LOCAL_GATEWAY_AUTH_BYPASS_ENABLED = LOCAL_DEVELOPER_FEATURES_ENABLED;

// Page Builder stays visible for local/Stage dark-candidate review. Production
// navigation requires an explicit build-time opt-in; legacy Shopify Pages stay separate.
export const PAGE_BUILDER_VISIBLE =
  !IS_PROD_ENV || import.meta.env['VITE_PAGE_BUILDER_ENABLED'] === 'true';

const parseOptionalNumber = (value: string | undefined) => {
  if (!value?.trim()) {
    return undefined;
  }

  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : undefined;
};

export const MTO_HOMEPAGE_ONE_VIEW_CARD_ID = parseOptionalNumber(
  import.meta.env['VITE_MTO_HOMEPAGE_ONE_VIEW_CARD_ID'],
);

/**
 * Where published skill bundles live: CloudFront distribution E3BBJUIA72ECYS, backed by
 * the dedicated skills bucket. The skills repo republishes these on every merge to main,
 * so they are served from their own origin rather than bundled with this app — an admin
 * deploy's `s3 sync --delete` would otherwise remove them.
 *
 * Bundles sit at the bucket root, so this carries no path segment.
 */
export const SKILLS_CDN_URL =
  (import.meta.env['VITE_SKILLS_CDN_URL'] as string | undefined) ??
  'https://d3oogiutwyitso.cloudfront.net';

export const DWARKA_FACILITY_ID = parseOptionalNumber(import.meta.env['VITE_DWARKA_FACILITY_ID']) ?? 1;
export const SAMALKHA_FACILITY_ID = parseOptionalNumber(import.meta.env['VITE_SAMALKHA_FACILITY_ID']) ?? 481;

/**
 * Hub gatepass creation/scanning is being rolled out to Samalkha first, so it is enabled only
 * for Samalkha (prod facility 480) and Samalkha RTV (facility 481); every other facility is
 * excluded for now. Prod is Samalkha only; stage/local also include AMB VK Store (47), the
 * canonical stage test facility that holds the seeded gatepass/shelf test data.
 */
export const GATEPASS_HUB_ENABLED_FACILITY_IDS: number[] = IS_PROD_ENV ? [480, 481] : [481, 47];

export const getAppName = () => {
  switch (PORTAL_NAME) {
    case 'admin': {
      return 'Foundation';
    }
    case 'logistics': {
      return 'Logistics';
    }
    case 'synq': {
      return 'Synq';
    }
    case 'vendor': {
      return 'Nexus';
    }
    case 'warehouse': {
      return 'Hub';
    }

    default: {
      return 'Foundation';
    }
  }
};
